module.exports = __webpack_public_path__ + "img/complete-img.38367fdf.jpg";